import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { DesktopIndex } from '../components/DesktopIndex';
import { MobileIndex } from '../components/MobileIndex';
import { Closing } from '../components/Closing';
import { VisionChapters } from '../components/chapters/VisionChapters';
import { ProgressionChapters } from '../components/chapters/ProgressionChapters';
import { EconomyChapters } from '../components/chapters/EconomyChapters';
import { CommitmentChapters } from '../components/chapters/CommitmentChapters';
export function Horizon() {
  useEffect(() => {
    document.title = 'Proyección de MU Vanguard';
  }, []);
  return <>
      <main data-id="element-2349" data-mp="5wvi2h8jszut">
        <Hero data-id="element-2350" data-mp="5x5bkessxp59" />
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-10 md:py-24" data-id="element-2351" data-mp="axszgrlqhpv9">
          <div className="grid gap-12 lg:grid-cols-[200px_minmax(0,1fr)] xl:gap-20" data-id="element-2352" data-mp="avovk9nu4quz">
            <aside className="hidden lg:block" data-id="element-2353" data-mp="27sfnir42oy4u">
              <DesktopIndex data-id="element-2354" data-mp="2comjbr2r8t92" />
            </aside>
            <article className="max-w-4xl min-w-0" data-id="element-2355" data-mp="2crihngiiljy1">
              <VisionChapters data-id="element-2356" data-mp="3kiox0j64gr4w" />
              <ProgressionChapters data-id="element-2357" data-mp="3kk05gwaiin2c" />
              <EconomyChapters data-id="element-2358" data-mp="3frp4dq41cv87" />
              <CommitmentChapters data-id="element-2359" data-mp="3fqnrrh7dg0od" />
            </article>
          </div>
        </div>
        <Closing data-id="element-2360" data-mp="3as449cd4qgtw" />
      </main>
      <MobileIndex data-id="element-2361" data-mp="3atf4j27d96g9" />
    </>;
}